import React from "react";
const MaleImage = ({ href }) => {
    return React.createElement("image", { className: "background-image", overflow: "visible", width: "730", height: "1370", href: href });
};
export default MaleImage;
//# sourceMappingURL=MaleImage.js.map